import * as APIRoutes from '@mm/api-routes';
import { EmailTemplatesPaginationModel } from '../model/EmailTemplatesModel';
import AuthenticatedController from './AuthenticatedController';

export default class EmailTemplatesController extends AuthenticatedController {
  static async getAll(
    orderColumn = 'sort_order',
    page = 1,
    perPage = 25,
  ): Promise<EmailTemplatesPaginationModel> {
    return super.get(APIRoutes.EMAIL_TEMPLATES({ orderColumn, page, perPage }));
  }
}
